/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2016 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

iaw.fnftEvents = {
	CUSTOMIZE_DOC:		'host-more-options',
	CREATE_DOC:			'host-create-template-doc',
	CANCEL_DOC:			'host-close-fnft',
	SCREEN_TEMPLATE:	'host-screen-template',
	FILTER:				'filter-templates'
};

/**
 * Handle the "Customize" button event
 */
riotctrl.on(iaw.fnftEvents.CUSTOMIZE_DOC, function() {
	if (window.__adobe_cep__) {
		iaw.fnft.createNewDocumentFromSelectedTemplate(true);
	}
});

/**
 * Handle the "Create Document" button event.
 */
riotctrl.on(iaw.fnftEvents.CREATE_DOC, (function() {
	var isCoolingDown = false;
	var coolDownTimer = 7000;

	return function() {
		if (window.__adobe_cep__) {
			
			if (isCoolingDown) return;

			isCoolingDown = true;
			setTimeout( function() {
				isCoolingDown = false;
			}, coolDownTimer);

			var template = iaw.fnft.getTemplateData(iaw.store.get(['input', 'selected-item']));
			if (template && !template.isPreset) {
				if (iaw.store.get(['host', 'hostID']) !== 'PHXS') {
					iaw.localstorage.setUserItem('templateLUT_' + template.id, new Date().getTime());
				}
				iaw.analytics.ingest.logFNFTActionClickedEvent('open-template', template);
				iaw.analytics.pip.logFNFTDataGroupEvent('Open Template', {
					id: String(template.id),
					name: template.title,
					templateCategory: template.template_category.toString(),
					activeTab: template.activeFilter
				});
			}
			iaw.fnft.createNewDocumentFromSelectedTemplate();
		}
		
	};
})());

/**
 * Handle the "Close" button event.
 */
riotctrl.on(iaw.fnftEvents.CANCEL_DOC, function() {
	if (!window.__adobe_cep__) return;

	window.__adobe_cep__.closeExtension();
});

/**
 * Handle the download template button event.
 */
riotctrl.on(iaw.fnftEvents.SCREEN_TEMPLATE, function() {
	var template = iaw.store.get(['input', 'preview-item']);
	iaw.analytics.ingest.logFNFTActionClickedEvent('download', template);
	var showScreen = iaw.localstorage.getUserItem('fnft.showFilesizeWarning');

	showScreen = typeof showScreen === 'boolean' ? showScreen : true;
	if (!showScreen) {
		iaw.analytics.ingest.logFNFTActionClickedEvent('license-template', template);
		riotctrl.trigger('host-license-template');
		return;
	}

	if (template.size / 1048576 > 100) {
		// warn the user that this is pretty big
		iaw.analytics.ingest.logFNFTActionClickedEvent('too-large-render', template);
		riotctrl.trigger('host-download-template--large');
		return;
	}
	// start the licensing process
	iaw.analytics.ingest.logFNFTActionClickedEvent('license-template', template);
	riotctrl.trigger('host-license-template');
});
